module.exports = __webpack_public_path__ + "static/media/exequiel_palacios.ba3d68ed.jpg";